function displayAlert() {
    $("#alertMessage").removeAttr("style");
    if (showAlert) {
        $("#alertMessage").attr("style", "display:block");
        //if (notificationDays >= 1) {
            //$("#notificationMessage").html(' Your password will expire in ' + notificationDays +  ' day(s) on ' + expirationDateTime + '. If you wish to change it now, use My Settings screen.');
        //} else {
            $("#notificationMessage").html(' Your password will expire on ' + expirationDateTime + '. If you wish to change it now, use My Settings screen.');
        //}

        $(document).ready(function() {
            $(".notification-bar").show().hide().delay(0).fadeIn("slow");
        });
    } else {
        $("#alertMessage").attr("style", "display:none");
    }
}


function displaySystemNotification() {
    $("#systemNotification").removeAttr("style");
    if (showSystemNotification) {
        $("#systemNotification").attr("style", "display:block");
            $("#systemNotificationMessage").html(systemMessage);
        $(document).ready(function() {
            $(".systemnotification-bar").show().hide().delay(0).fadeIn("slow");
        });
    } else {
        $("#systemNotification").attr("style", "display:none");
    } 
}

var showSystemNotification = false;
var systemMessage = ''; 

var showAlert = false;
var notificationDays = 0; 
var expirationDateTime = ''; 




window.onload = function(){
    window.myfunc();
}

window.onload=function(){
$.fn.focusNextInputField = function () {
    return this.each(function () {
        var fields = $(this).parents('form:eq(0),body').find('button,input,textarea,select');
        var index = fields.index(this);
        if (index > -1 && (index + 1) < fields.length) {
            fields.eq(index + 1).focus();
        }
        return false;
    });
};

$('body').on('keydown', 'input[type=date]', function(e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 9) {
        e.preventDefault();
        $(this).focusNextInputField();
    }
});


$("input[type=date]").on('keydown', function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 9) {
        e.preventDefault();
        $(this).focusNextInputField();
    }
}); 

$(document).on('click',
    '.popup-marker',
    function () {
        $(this).popover({ container: 'body'}).popover('toggle');
    });
}